"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHead = void 0;

var _react = _interopRequireDefault(require("react"));

var _TableHead = _interopRequireDefault(require("@mui/material/TableHead/TableHead.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _excluded = ["dark", "children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _makeStyles.default)({
  root: function root(_ref) {
    var dark = _ref.dark;
    return {
      backgroundColor: dark ? _Colors.default.textElementGrey : _Colors.default.white,
      top: 0,
      zIndex: 2,
      '& svg': {
        fill: dark ? _Colors.default.white : _Colors.default.textElementGrey
      },
      '& *': {
        color: dark ? _Colors.default.white : _Colors.default.textElementGrey
      }
    };
  }
});

var TableHead = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var dark = props.dark,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _useStyles = useStyles({
    dark: dark
  }),
      root = _useStyles.root;

  return /*#__PURE__*/_react.default.createElement(_TableHead.default, _extends({
    ref: ref
  }, rest, {
    className: "".concat(root, " ").concat(className)
  }), children);
});

exports.TableHead = TableHead;